export const EQUIPMENT_STATUS = {
  PRE_REGISTER: 'pre-register',
  REGISTERED: 'registered',
  DISCARDED: 'discarded',
};
